// import axios from "axios";
// import { url } from "./utils/url";
// import authHeader from "./utils/auth-header";
import { v4 } from "uuid";

let pushNotifications = [
  {
    id: v4(),
    message: `Did somebody say Black Truffle Burger?
    You’re gonna dig this! Try one at Il Baretto.`,
    dateSent: "2023-06-10T11:00:00.000Z",
  },
  {
    id: v4(),
    message: `New Shop Alert!
    Get a 10% off with code KAFDNEWSHOP exclusively at Cha Cafe.`,
    dateSent: "2023-06-11T12:30:00.000Z",
  },
  {
    id: v4(),
    message: "New restaurant in KAFD!",
    dateSent: "2023-06-11T13:30:00.000Z",
  },
  {
    id: v4(),
    message: "New shop in KAFD!",
    dateSent: "2023-06-12T10:15:00.000Z",
  },
  {
    id: v4(),
    message: "New museum in KAFD!",
    dateSent: "2023-06-12T13:00:00.000Z",
  },
  {
    id: v4(),
    message: "New mall in KAFD!",
    dateSent: "2023-06-13T11:00:00.000Z",
  },
  {
    id: v4(),
    message: "New offices in KAFD!",
    dateSent: "2023-06-13T13:30:00.000Z",
  },
];

class PushNotificationApi {
  static async getAll() {
    // const result = await axios.get(`${url}/admin/push-notifications`, {
    //   headers: authHeader(),
    // });
    // return result.data;

    // TODO [GSO]: real request
    const result = await new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(pushNotifications);
      }, 300);
    });
    return result;
  }

  static async create(body: any) {
    // const result = await axios.post(`${url}/admin/push-notifications`, body, {
    //   headers: authHeader(),
    // });
    // return result.data;

    // TODO [GSO]: real request
    const newPushNotification = {
      ...body,
      id: v4(),
      dateSent: new Date().toISOString(),
    };
    pushNotifications.unshift(newPushNotification);

    const result = await new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(newPushNotification);
      }, 300);
    });
    return result;
  }
}

export default PushNotificationApi;
